module.exports = __webpack_public_path__ + "img/icon3.27d870f3.png";